import DatasetChip from 'components/CleanRooms/CurrentQuestions/DatasetChip';
import React, { memo } from 'react';
import Stack from '@mui/material/Stack';
import Status from 'BaseComponents/MotifStatus';
import get from 'lodash/get';
import { Typography } from '@mui/material';
import { crQuestionStage } from 'utils/ignoramusEnums';


export const StageLabel = ({ row }) => {
  const label = get(crQuestionStage, `${row.stage}.label`);
  const color = get(crQuestionStage, `${row.stage}.color`);

  return (
    <Stack direction='row' alignItems='center' spacing={1}>
      <Status color={color}>
        <Typography variant='body3'>
          {label}
        </Typography>
      </Status>
    </Stack>
  );
};

export const DatasetsManagementCell = memo(({ row }) => (
  <Stack direction='row' spacing={1} alignItems='center'>
    <DatasetChip question={row} />
    <StageLabel row={row} />
  </Stack>
));

DatasetsManagementCell.displayName = 'DatasetsManagementCell';
